import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import BaseComponent from 'foundation/base-component';
import store from 'general/js/store';
import LiveStatsLayout from './live-stats-layout';

class LiveStatsComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        this.render();
    }

    destroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <LiveStatsLayout options={this.options} />
            </Provider>,
            this.element
        );
    }
}

export default LiveStatsComponent;
